angular.module('salesPath2')
  .service('apkErrorsHelper', ['sp2CommonHelper', 'sp2UiHelper', 'dataContainerHelper', 'apkRestSvc', 'ihestiaConfigHelper', 'actionHelper', '$location', 'policyApkSvc', '$window',
    function(sp2CommonHelper, sp2UiHelper, dataContainerHelper, apkRestSvc, ihestiaConfigHelper, actionHelper, $location, policyApkSvc, $window) {
      var ApkErrorsHelper = function() {
        var self = this;

        //ustawienia modali
        this.modals = {};
        this.portalUrl = ihestiaConfigHelper.getUrl('PORTAL_URL');
        this.apkDetails = dataContainerHelper.getApk();
        this.policyId = null;
        this.policySymbol = null;

        this.modals.apkTimeoutModal = {
          settings: {
            treatLabelAsI18nCode: true,
            title: 'sp2.modal.apk.title',
            size: 'sm',
            okBtnName: 'sp2.modal.continue',
            cancelBtnName: 'sp2.modal.refresh',
            keyboard: false
          }
        };

        this.modals.apkExternalModal = {
          settings: {
            treatLabelAsI18nCode: true,
            title: 'sp2.modal.apk.title',
            size: 'sm',
            okBtnName: 'sp2.modal.apk.yes',
            cancelBtnName: 'sp2.modal.cancel',
            keyboard: false
          }
        };

        this.modals.apkMissingModal = {
          settings: {
            treatLabelAsI18nCode: true,
            title: 'sp2.modal.apk.title',
            size: 'sm',
            okBtnName: 'sp2.modal.close',
            cancelBtnName: false,
            keyboard: false
          }
        };

        this.modals.apkForbiddenModal = {
          settings: {
            treatLabelAsI18nCode: true,
            title: 'sp2.modal.apk.title',
            size: 'sm',
            okBtnName: 'sp2.modal.close',
            cancelBtnName: false,
            keyboard: false
          }
        };

        this.modals.apkNotFoundModal = {
          settings: {
            treatLabelAsI18nCode: true,
            title: 'sp2.modal.apk.title',
            size: 'sm',
            okBtnName: 'sp2.modal.close',
            cancelBtnName: false,
            keyboard: false
          }
        };

        this.modals.apkRenewalModal = {
          settings: {
            treatLabelAsI18nCode: true,
            title: 'sp2.modal.apk.title',
            size: 'sm',
            okBtnName: 'sp2.modal.refresh',
            cancelBtnName: 'sp2.modal.close',
            keyboard: false
          }
        };

        /**
         * Wyświetlenie modala
         */
        this.showApkTimeoutModal = function() {
          sp2CommonHelper.showModal('apkTimeoutModal');
        };

        /**
         * Wyświetlenie modala
         */
        this.showApkExternalModal = function() {
          sp2CommonHelper.showModal('apkExternalModal');
        };

        this.getApkDetails = function(actionParams) {
          sp2UiHelper.showBlockUi();
          return apkRestSvc.getApk(actionParams.apkid, function(response) {
            sp2UiHelper.hideBlockUi();
            dataContainerHelper.setApkDetails(response.data);
            dataContainerHelper.setApk({apkNumber: response.data.code});
            actionHelper.runAction('apkDetailsSet');
          }, function(reject) {         
            sp2UiHelper.hideBlockUi();     
            switch (reject.status) {
              case 403:
                sp2CommonHelper.showModal('apkForbiddenModal');
                break;            
              case 404:       
              case 409:
                sp2CommonHelper.showModal('apkNotFoundModal');
                break;
              default:
                sp2CommonHelper.showModal('apkTimeoutModal');
                break;
            }
          });
        };

        this.renewPolicy = function() {
          sp2UiHelper.showBlockUi();
          var apkUrl = ihestiaConfigHelper.getUrl('APK_URL');
          var currentUrl = $location.absUrl().replace('#', 'external');
          policyApkSvc.getPolicyDetails(self.policyId, self.policySymbol, currentUrl, function() {  
            var url = apkUrl + 'apk/renewal?policyId='+ self.policyId;
            $window.open(url, '_self');
          }, function(reject) {       
            sp2UiHelper.hideBlockUi();       
            switch (reject.status) {
              case 403:
                sp2CommonHelper.showModal('apkForbiddenModal');
                break;            
              case 404:       
              case 409:
                sp2CommonHelper.showModal('apkNotFoundModal');
                break;
              default:
                sp2CommonHelper.showModal('apkRenewalModal');
                break;
            }
          });
        };
      };

      return new ApkErrorsHelper();
    }
  ]);
